import React from 'react';
import { twMerge } from 'tailwind-merge';

type WebUiPageWrapperProps = {
  titleList: string[];
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
  children: React.ReactNode;
};

export default function WebUiPageWrapper({
  titleList,
  children,
  className,
  titleClassName,
  contentClassName,
}: WebUiPageWrapperProps) {
  return (
    <div className={twMerge('webui-page-wrapper', className)}>
      <h2 className={twMerge('webui-page-title mb-2', titleClassName)}>
        {titleList.join(' > ')}
      </h2>
      <div
        className={twMerge(
          'flex h-full w-full flex-col gap-2',
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}
